export default __webpack_public_path__ + "static/media/greeting1.e4a54da8.png";